/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 6/11/15,
 * Converted to TypeScript by kyang on 8/7/2019
 */

function CustomMetadataComponent(
    this: JS5Object,
    _: JS5Object
) {

    let prevComponentsMap: JS5Object;


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$doCheck = () => {
        if (prevComponentsMap !== this.componentsMap) {
            this.orderedComponents = _.sortBy(this.componentsMap, (componentDef: JS5Object) => {
                return parseInt(componentDef.displayIndex);
            });
            prevComponentsMap = this.componentsMap;
        }
    };

    this.$onInit = () => {
        this.orderedComponents = this.orderedComponents || [];
    };

}

angular.module('prism-ui.components').component('customMetadata', {
    templateUrl: 'components/form/customMetadata/custom-metadata-template.html',
    controller: CustomMetadataComponent,
    bindings: {
        componentsMap: '=',
        componentStyleOverrides: '=',
        disableComponents: '=',
        idPrefix: '@',
        ignorePreferredWidth: '=',
        labelColSize: '@',
        onUpdate: '&',
        revision: '=', // partner package revision
    }
});



